import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const agendaContainerFields: FieldInterface[] = []

export const AgendaClientAccessKey = '_clientAccess'
export const AgendaTechnicalContextsKey = '_technicalContexts'
export const AgendaReasonsKey = '_reasons'
export const AgendaAppointmentsKey = '_appointments'
export const AgendaAppointmentDetailsKey = '_appointmentDetails'
export const AgendaFinancialAdvisorsKey = '_financialAdvisors'
export const AgendaFinancialAdvisorAvailabilitiesKey =
  '_financialAdvisorAvailabilities'
export const AgendaFinancialAdvisorAvailabilityDetailsKey =
  '_financialAdvisorAvailabilityDetails'
export const AgendaClientPhonesKey = '_clientPhones'
export const AgendaNewAppointmentsKey = '_newAppointments'

export const CODE_PLACE_APPOINTMENT = {
  TL: 'TL',
  AG: 'AG',
}

export const TOP_SMS = {
  true: 'true',
  false: 'false',
}

export const agendaContainerRelations: RelationInterface[] = [
  {
    key: AgendaClientAccessKey,
    originKey: 'client_access',
    objectType: OBJECT_TYPES.agendaClientAccesses,
  },
  {
    key: AgendaTechnicalContextsKey,
    originKey: 'technical_context',
    objectType: OBJECT_TYPES.agendaTechnicalContexts,
  },
  {
    key: AgendaReasonsKey,
    originKey: 'reasons',
    objectType: OBJECT_TYPES.agendaReasons,
    isMultiple: true,
  },
  {
    key: AgendaAppointmentsKey,
    originKey: 'appointments',
    objectType: OBJECT_TYPES.agendaAppointments,
    isMultiple: true,
  },
  {
    key: AgendaAppointmentDetailsKey,
    originKey: 'appointment_details',
    objectType: OBJECT_TYPES.agendaAppointmentDetails,
    isMultiple: true,
  },
  {
    key: AgendaFinancialAdvisorsKey,
    originKey: 'financial_advisors',
    objectType: OBJECT_TYPES.agendaFinancialAdvisors,
    isMultiple: true,
  },
  {
    key: AgendaFinancialAdvisorAvailabilitiesKey,
    originKey: 'availabilities',
    objectType: OBJECT_TYPES.agendaFinancialAdvisorAvailabilities,
    isMultiple: true,
  },
  {
    key: AgendaFinancialAdvisorAvailabilityDetailsKey,
    originKey: 'availability_detail', // no plural here (╯°□°)╯︵ ┻━┻
    objectType: OBJECT_TYPES.agendaFinancialAdvisorAvailabilityDetails,
  },
  {
    key: AgendaClientPhonesKey,
    originKey: 'client_phone_numbers',
    objectType: OBJECT_TYPES.agendaClientPhoneNumbers,
    isMultiple: true,
  },
  {
    key: '_newAppointments',
    originKey: 'new_appointment',
    objectType: OBJECT_TYPES.agendaNewAppointments,
  },
]

export const agendaClientAccessFields: FieldInterface[] = [
  {
    key: 'canListAppointments',
    originKey: 'is_access_to_make_an_appointment',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'isAvailableForAppointments',
    originKey: 'is_available_for_appointments',
    type: FIELD_TYPES.boolean,
  },
]

export const agendaTechnicalContextFields: FieldInterface[] = [
  {
    key: 'token',
    originKey: 'token',
    type: FIELD_TYPES.string,
  },
]

export const agendaReasonFields: FieldInterface[] = [
  {
    key: 'label',
    originKey: 'label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'typeOfNature',
    originKey: 'type_of_nature',
    type: FIELD_TYPES.string,
  },
  {
    key: 'labelOfNature',
    originKey: 'label_of_nature',
    type: FIELD_TYPES.string,
  },
  {
    key: 'agencyDuration',
    originKey: 'agency_duration',
    type: FIELD_TYPES.string,
  },
  {
    key: 'phoneDuration',
    originKey: 'phone_duration',
    type: FIELD_TYPES.string,
  },
  {
    key: 'codes',
    originKey: 'codes',
    type: FIELD_TYPES.object,
    objectType: FIELD_TYPES.string,
    isMultiple: true,
  },
]

export const agendaAppointmentFields: FieldInterface[] = [
  {
    key: 'appointmentDate',
    originKey: 'appointment_date',
    type: FIELD_TYPES.string,
  },
  {
    key: 'startHour',
    originKey: 'start_hour',
    type: FIELD_TYPES.string,
  },
  {
    key: 'endHour',
    originKey: 'end_hour',
    type: FIELD_TYPES.string,
  },
  {
    key: 'financialAdvisorFirstName',
    originKey: 'financial_advisor_first_name',
    type: FIELD_TYPES.string,
  },
  {
    key: 'financialAdvisorLastName',
    originKey: 'financial_advisor_last_name',
    type: FIELD_TYPES.string,
  },
  {
    key: 'financialAdvisorCivility',
    originKey: 'financial_advisor_civility',
    type: FIELD_TYPES.string,
  },
  {
    key: 'appointmentDayCode',
    originKey: 'appointment_day_code',
    type: FIELD_TYPES.string,
  },
  {
    key: 'appointmentPlace',
    originKey: 'appointment_place',
    type: FIELD_TYPES.string,
    enumKeys: [CODE_PLACE_APPOINTMENT.AG, CODE_PLACE_APPOINTMENT.TL],
  },
  {
    key: 'appointmentDuration',
    originKey: 'appointment_duration',
    type: FIELD_TYPES.string,
  },
  {
    key: 'isAppointmentModifiable',
    originKey: 'is_appointment_modifiable',
    type: FIELD_TYPES.boolean,
  },
  {
    key: 'agencyLocation',
    originKey: 'agency_location',
    type: FIELD_TYPES.string,
  },
  {
    key: 'clientPhoneNumber',
    originKey: 'client_phone_number',
    type: FIELD_TYPES.string,
  },
  {
    key: 'appointmentComment',
    originKey: 'appointment_comment',
    type: FIELD_TYPES.string,
  },
  {
    key: 'appointmentCommentClient',
    originKey: 'appointment_comment_client',
    type: FIELD_TYPES.string,
  },
  {
    key: 'reasonId',
    originKey: 'reason_id',
    type: FIELD_TYPES.string,
  },
  {
    key: 'reasonLabel',
    originKey: 'reason_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'typeOfNature',
    originKey: 'type_of_nature',
    type: FIELD_TYPES.string,
  },
  {
    key: 'labelOfNature',
    originKey: 'label_of_nature',
    type: FIELD_TYPES.string,
  },
  {
    key: 'isCommentModifiable',
    originKey: 'is_comment_modifiable',
    type: FIELD_TYPES.boolean,
  },
]

export const agendaClientPhoneNumbersFields: FieldInterface[] = [
  {
    key: 'clientPhoneNumber',
    originKey: 'client_phone_number',
    type: FIELD_TYPES.string,
  },
]

export const agendaFinancialAdvisorsFields: FieldInterface[] = [
  {
    key: 'civilityAbbr',
    originKey: 'civility_abbr',
    type: FIELD_TYPES.string,
  },
  {
    key: 'lastName',
    originKey: 'last_name',
    type: FIELD_TYPES.string,
  },
  {
    key: 'firstName',
    originKey: 'first_name',
    type: FIELD_TYPES.string,
  },
  {
    key: 'isOnline',
    originKey: 'is_online',
    type: FIELD_TYPES.boolean,
  },
]

export const agendaFinancialAdvisorAvailabilitiesFields: FieldInterface[] = [
  {
    key: 'startHour',
    originKey: 'start_hour',
    type: FIELD_TYPES.string,
  },
  {
    key: 'endHour',
    originKey: 'end_hour',
    type: FIELD_TYPES.string,
  },
  {
    key: 'availabilityDate',
    originKey: 'availability_date',
    type: FIELD_TYPES.string,
  },
  {
    key: 'availabilityDayCode',
    originKey: 'availability_day_code',
    type: FIELD_TYPES.string,
  },
  {
    key: 'agencyName',
    originKey: 'agency_name',
    type: FIELD_TYPES.string,
  },
  {
    key: 'agencyAddress',
    originKey: 'agency_address',
    type: FIELD_TYPES.string,
  },
  {
    key: 'agencyLocation',
    originKey: 'agency_location',
    type: FIELD_TYPES.string,
  },
]

export const agendaFinancialAdvisorAvailabilityDetailsFields: FieldInterface[] =
  [
    {
      key: 'duration',
      originKey: 'duration',
      type: FIELD_TYPES.string,
    },
    {
      key: 'numberOfAvailabilities',
      originKey: 'number_of_availabilities',
      type: FIELD_TYPES.string,
    },
    {
      key: 'smsPhoneNumber',
      originKey: 'sms_phone_number',
      type: FIELD_TYPES.string,
    },
    {
      key: 'smsReminder',
      originKey: 'sms_reminder',
      type: FIELD_TYPES.string,
    },
  ]

export const agendaNewAppointmentsFields: FieldInterface[] = [
  {
    key: 'isNewAppointmentPossible',
    originKey: 'is_new_appointment_possible',
    type: FIELD_TYPES.boolean,
  },
]
